import React from "react";
import { observer } from "mobx-react-lite";

import "./BatchProcessingProgressSnackbar.scss";
import Button from "../button/Button";
import ProgressBarSnackbar from "../progress-bar-snackbar/ProgressBarSnackbar";
import { Info } from "../svg/svgImageList";
import { translationService } from "../../services/translation/TranslationService";
import { batchVideoAnalysisService } from "../../services/batch-processing/BatchVideoAnalysisService";

export default observer(function BatchVideoAnalysisProgressSnackbar() {
  return (
    <div
      className={`batch-processing-progress ${
        batchVideoAnalysisService.statusModel.displaySnackbar ? "show" : "hide"
      }`}
    >
      <div className="info">
        <Button
          className="svg-info"
          icon={{
            svg: Info,
            width: 30,
            height: 30,
          }}
        />
        <span>
          {translationService.translate("damages.BatchProcessingProgress.title", {
            itemsCount: batchVideoAnalysisService.statusModel.videoCount,
          })}
          {translationService.translate("damages.BatchProcessingProgress.title.VideoAnalysis")}
        </span>
        <Button
          className={"btn-text"}
          textKey="general.upload.view-details"
          onClick={batchVideoAnalysisService.statusModel.showStatusBatchModal}
        />
      </div>
      <div className="progress-bar-with-stop">
        <ProgressBarSnackbar
          percentComplete={batchVideoAnalysisService.statusModel.percentComplete}
        />
        <span>
          {`${batchVideoAnalysisService.statusModel.successfullyCount} /
            ${batchVideoAnalysisService.statusModel.videoCount}`}
        </span>
      </div>
    </div>
  );
});
